<section
    class="drop-zone"
    [class.drag-over]="isDragOver"
    [class.disabled]="disabled || isFull"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)">
    <input
        id="upload-input"
        type="file"
        accept=".txt,.pdf,.docx"
        multiple
        [disabled]="disabled || isFull"
        (change)="onFilePick($event)" />
    <label for="upload-input" class="prompt" *ngIf="!isFull; else fullLabel">
        <span class="icon" aria-hidden="true">&#x2191;</span>
        <span>
            <strong>Drop a file</strong> or <span class="link">browse</span>
            — up to {{ maxFiles }} files (txt, pdf, docx, ≤ 10 MB each)
        </span>
    </label>
    <ng-template #fullLabel>
        <span class="prompt full">Maximum {{ maxFiles }} files reached</span>
    </ng-template>
</section>

<ul class="chips" *ngIf="chips.length > 0">
    <li *ngFor="let chip of chips" class="chip" [attr.data-status]="chip.status">
        <div class="chip-main">
            <span class="chip-name">{{ chip.fileName }}</span>
            <span class="chip-size">{{ formatSize(chip.sizeBytes) }}</span>
            <span class="chip-status">
                <ng-container [ngSwitch]="chip.status">
                    <span *ngSwitchCase="'uploading'">Uploading…</span>
                    <span *ngSwitchCase="'extracted'">Ready</span>
                    <span *ngSwitchCase="'failed'">Failed</span>
                </ng-container>
            </span>
            <button type="button" class="chip-remove" (click)="remove(chip.localId)" aria-label="Remove file">×</button>
        </div>
        <p class="chip-error" *ngIf="chip.status === 'failed' && chip.failureLabel">
            {{ chip.failureLabel }}
        </p>
    </li>
</ul>
